<!-- Footer -->
<p class="clearfix mb-0">
  <span class="float-md-left d-block d-md-inline-block mt-25">
    COPYRIGHT &copy; {{ year }}
    <a class="ml-25" href="https://lockminds.com" target="_blank">Powered by Lockminds</a>
    <span class="d-none d-sm-inline-block">, All rights Reserved</span>
  </span>
  <span *ngIf="connectionStatus == false" class="float-md-right d-none d-md-block">
     <span [data-feather]="'wifi-off'" [class]="'pink'"></span>
  </span>
  <span *ngIf="connectionStatus == true" class="float-md-right d-none d-md-block">
     <span [data-feather]="'wifi'" [class]="'text-success'"></span>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>


